'use strict';

customerZone.service('OrderService', ['UnleashedClient', 'utils', '$location', '$q', '$log', '$rootScope', 'Session',
    function(api, utils, $location, $q, $log, $rootScope, Session){

        var self = this;
        var _pendingOrders = utils.lazyPromise(function(){
            return api.getPendingOrders();
        });

        self.refreshPendingOrders = function(){
            _pendingOrders = api.getPendingOrders();
        };

        $rootScope.$on(Session.PROFILE_CHANGED_EVENT, function(){
            if (!Session.authenticated()) return;
            $log.debug('profile changed - updating pending orders', Session.authenticated());
            self.refreshPendingOrders();
        });

        /**
         * Checks if there are awaiting sim orders
         * @return {promise} to a boolean, true if it's the case
         */
        self.checkForAwaitingSimOrder = function(subscriptionId){
            return self.getAllOrdersOfType(jim.OrderType.ORDER_A_SIM, subscriptionId)
                .then(function(orders){
                    return orders.length > 0;
                });
        };

        /**
         * Will get all pending orders, preferably from the cache.
         * Except if it detects that an order is about to change from state,
         * then it will trigger the refresh of the pending cached orders.
         * @return all pending orders
         */
        self.getPendingOrders = function(){
            _pendingOrders.then(function(pendingOrders){
                var aboutToChangeStateOrders = pendingOrders.filter(function(order){
                    return (order.type === jim.OrderType.ORDER_A_SIM || order.type === jim.OrderType.SIM_ACTIVATION)
                        && order.state ===  jim.OrderState.processing;
                });
                if (aboutToChangeStateOrders.length !== 0) self.refreshPendingOrders();
            });
            return _pendingOrders;
        };

        self.getPendingOrdersBySubscription = function(subscriptionId){
            return self.getPendingOrders().then(function(orders){
                return orders.filter(function(order){
                    return subscriptionId === order.subscriptionId;
                });
            });
        };

        /**
         * @return pending orders of the given type
         */
        self.getAllOrdersOfType = function(type, subscriptionId){
            var ordersPromise =
                (subscriptionId) ? self.getPendingOrdersBySubscription(subscriptionId) : self.getPendingOrders();
            return ordersPromise.then(
                function(orders){
                    return orders.filter(function(order){
                        return order.type === type;
                    });
                });
        };

        /**
         * Get orders awaiting for payments
         * @return {promise} to an array of orders
         */
        self.getAwaitingOrders = function() {
            return api.getOrdersInState([jim.OrderState.waiting_for_payment]);
        };

        /**
         * Get orders in the state "wait for sim"
         * @return {promise} to an array of orders
         */
        self.getOrdersWaitingForSim = function() {
            return api.getOrdersInState(
                [jim.OrderState.waiting_for_sim, jim.OrderState.waiting_for_internal_processing]);
        };

        self.getOrdersWaitingForSimMatching = function(){
            return api.getOrdersInState([jim.OrderState.waiting_for_sim_matching]);
        };

        self.getEnabledOrInReviewNeededSimSwapOrders = function() {
            return api.getTypedOrdersInState([jim.OrderType.ORDER_A_SWAP],
                [jim.OrderState.enabled, jim.OrderState.review_needed]);
        };

        self.loadMnpDetails = function(){
            return self.getAllOrdersOfType(jim.OrderType.SIM_ACTIVATION)
                .then(function(activationOrders){
                    var parentPromises = activationOrders
                        .filter(byState(jim.OrderState.mnp_rejected))
                        .filter(function(order){ return order.parentOrderId; })
                        .map(function(order){ return self.getOrder(order.parentOrderId); });
                    return $q.all(parentPromises);
                })
                .then(function(creationOrders){
                    var donorInfos = creationOrders
                        .filter(function(order){ return order.donor && order.donor.msisdn; })
                        .map(function(order){
                            return {
                                creationOrder: order.id,
                                msisdn: order.donor.msisdn,
                                donorIccid: order.donor.donorIccid,
                                donorOperator: order.donor.donorOperator,
                                donorType: order.donor.donorType
                            };
                        });
                    return donorInfos[0] || {};
                });
        };

        self.updateMnpDetails = function(orderId, mnpDetails){
            return api.updateMnpDetails(orderId, mnpDetails);
        };

        /**
         *  Find and remove (if found) the actual fetched order in cache
         */
        var removeOrderFromCache = function(pendingOrders, orderId){
            var index = pendingOrders.findIndex(function(elem){
                return elem.id === orderId;
            });
            if (index > -1){
                pendingOrders.splice(index, 1);
            }
        };

        /**
         * Add an order to the cache if it is in a pending state
         * @param pendingOrders
         * @param order
         */
        var addOrderToCache = function(pendingOrders, order){
            if (jim.values(jim.OrderState)
                .except(jim.OrderState.cancelled, jim.OrderState.failed, jim.OrderState.enabled)
                .includes(order.state)){
                pendingOrders.push(order);
            }
        };

        /**
         * Retrieve an order.  The order will be populated with its products and its type.
         * @param id
         * @return a promise to the order with given ID.
         */
        self.getOrder = function(id){
            return api.getOrder(id).then(function(order){
                return _pendingOrders.then(function(pendingOrders){
                    removeOrderFromCache(pendingOrders, id);
                    addOrderToCache(pendingOrders, order);
                    return order;
                });
            });
        };

        var byState = function(state){
            return function(order){
                return order.state === state;
            };
        };

    }]);
